import React, {Component} from "react";
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {ModalBody, ModalFooter} from "reactstrap";
import {Switch} from "../buttons/Swtich";
import {TimezoneSelect} from "../selects/TimezoneSelect";

export class EditAgencyManagerLimitForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            saving: false,
            adSpentLimitAllTime: this.props.adSpentLimitAllTime,
            pauseAllCampaignsOnLimitExceededAllTime: this.props.pauseAllCampaignsOnLimitExceededAllTime,
            adSpentLimitTodayAtTimezone: this.props.adSpentLimitTodayAtTimezone,
            pauseAllCampaignsOnLimitExceededTodayAtTimezone: this.props.pauseAllCampaignsOnLimitExceededTodayAtTimezone,
            timezoneForTodayLimit: this.props.timezoneForTodayLimit
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleTimezoneChange = this.handleTimezoneChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});
        let submit_url = API_URL + `manage-accounts/agency-manager-limit/${this.props.agencyManagerLimitConfigurationId}/`;
        const data = {
            'ad_spent_limit_all_time': this.state.adSpentLimitAllTime,
            'pause_all_campaigns_on_limit_exceeded_all_time': this.state.pauseAllCampaignsOnLimitExceededAllTime,
            'ad_spent_limit_today_at_timezone': this.state.adSpentLimitTodayAtTimezone,
            'pause_all_campaigns_on_limit_exceeded_today_at_timezone': this.state.pauseAllCampaignsOnLimitExceededTodayAtTimezone,
            'timezone_for_today_limit': this.state.timezoneForTodayLimit
        };
        new APIClient(submit_url).call('POST', data).then((response) => {
            this.setState({saving: false});
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (response.status === 'OK') {
                this.props.onModified(response.data);
            }
        })
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            return <input type="submit" value="Guardar" className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const switchesNames = ["pauseAllCampaignsOnLimitExceededAllTime", "pauseAllCampaignsOnLimitExceededTodayAtTimezone"]
        const value = switchesNames.includes(name) ? target.checked : target.value;

        this.setState({
            ...this.state,
            [name]: value
        });
    }

    handleTimezoneChange(newTimezone) {
        this.setState({
            ...this.state,
            timezoneForTodayLimit: newTimezone
        });
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>Límite Histórico</label>
                            <input name="adSpentLimitAllTime" type="number" onChange={this.handleChange}
                                   value={this.state.adSpentLimitAllTime}/>
                        </div>
                    </div>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>Pausar todas las campañas de todas las cuentas si se supera el límite histórico</label>
                            <Switch onChange={this.handleChange}
                                    checked={this.state.pauseAllCampaignsOnLimitExceededAllTime}
                                    name="pauseAllCampaignsOnLimitExceededAllTime"
                                    messageToAlertUserIfChecked={null}
                            />
                        </div>
                    </div>


                    <div className="modal-section">
                        <div className="form-row">
                            <label>Límite Diario</label>
                            <input name="adSpentLimitTodayAtTimezone" type="number" onChange={this.handleChange}
                                   value={this.state.adSpentLimitTodayAtTimezone}/>
                        </div>
                    </div>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>Huso horario</label>
                            <TimezoneSelect selectedOption={this.state.timezoneForTodayLimit} onTimezoneChange={this.handleTimezoneChange} />
                        </div>
                    </div>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>Pausar todas las campañas de todas las cuentas si se supera el límite diario</label>
                            <Switch onChange={this.handleChange}
                                    checked={this.state.pauseAllCampaignsOnLimitExceededTodayAtTimezone}
                                    name="pauseAllCampaignsOnLimitExceededTodayAtTimezone"
                                    messageToAlertUserIfChecked={null}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }
}
